// Iris brand config, sourced from build-time env (see .env). The visible brand
// name/domain live here + as %VITE_*% tokens in the HTML — not hardcoded in markup.
// This is the JS-side counterpart used by code snippets (domains, package names).
const env = import.meta.env;

function configuredUrl(value, fallback = "") {
  const raw = String(value == null ? "" : value).trim();
  if (!raw || raw === "#") return fallback;
  return raw;
}

export const brand = {
  name: env.VITE_PRODUCT_NAME || "Iris",
  domain: env.VITE_PRODUCT_DOMAIN || "irissays.com",
  agent: env.VITE_AGENT_NAME || "Iris",
  company: env.VITE_COMPANY || "Unified Imaging",
  pkgScope: env.VITE_PKG_SCOPE || "irissays",
  apiBase:
    env.VITE_API_BASE ||
    "https://unichat-staging-server.yellowforest-cd2ec69d.eastus.azurecontainerapps.io",
  cdnBase:
    env.VITE_CDN_BASE || "https://unichatstaginsa.z13.web.core.windows.net",
  rtBase:
    env.VITE_RT_BASE ||
    "wss://unichat-staging-server.yellowforest-cd2ec69d.eastus.azurecontainerapps.io",
  year: env.VITE_COPYRIGHT_YEAR || "2026",
  // Cross-surface links. NOTE: vite.config's BRAND_DEFAULTS only feed the
  // %VITE_*% HTML token replacement — they never reach import.meta.env — so
  // JS-side fallbacks must live here for anything read from JS.
  loginUrl: configuredUrl(env.VITE_LOGIN_URL, "/admin.html"),
  adminUrl: configuredUrl(env.VITE_ADMIN_URL, "/admin.html"),
  consoleUrl: configuredUrl(env.VITE_CONSOLE_URL, ""),
};

export function applySurfaceLinks(root = document) {
  root.querySelectorAll("[data-login-link]").forEach((el) => {
    el.setAttribute("href", brand.loginUrl);
  });
  root.querySelectorAll("[data-admin-link]").forEach((el) => {
    el.setAttribute("href", brand.adminUrl);
  });
  root.querySelectorAll("[data-console-link]").forEach((el) => {
    if (brand.consoleUrl) {
      el.setAttribute("href", brand.consoleUrl);
      el.classList.remove("is-disabled");
      el.removeAttribute("aria-disabled");
      el.removeAttribute("title");
      return;
    }
    el.removeAttribute("href");
    el.classList.add("is-disabled");
    el.setAttribute("aria-disabled", "true");
    el.setAttribute(
      "title",
      el.getAttribute("data-console-unavailable-title") ||
        "Operator portal URL is not configured for this deployment.",
    );
    const label = el.querySelector("[data-console-label]");
    if (label) {
      label.textContent =
        el.getAttribute("data-console-unavailable-label") ||
        "Portal URL not configured";
    }
  });
}

// Runtime fallback: fill any element marked data-brand="<key>" with brand[key].
// (HTML already uses %VITE_*% tokens for the static spots; this covers anything
// rendered/templated client-side.)
export function applyBrand(root = document) {
  root.querySelectorAll("[data-brand]").forEach((el) => {
    const key = el.getAttribute("data-brand");
    if (brand[key] != null) el.textContent = brand[key];
  });
  applySurfaceLinks(root);
}
